import { Data2, newId } from '../../../features/data-types'
import { O } from '../../../features/ui'
import { Currency, TableName } from '../../../tables/types/types'
import { Discount } from '../../common'
import { usePurchaseBuilders } from '../../purchases'
import { useSaleBuilders, useHoardBuilders } from '../../sales'
import { Item, ItemDeliveryStats, ItemInvoiceStats } from '../state/types'

export const useOperationBuilders = () => {
    const { buildPurchase } = usePurchaseBuilders()
    const { buildSale } = useSaleBuilders()
    const { buildHoard } = useHoardBuilders()

    const buildOperation = (table: TableName, data: Data2) => {
        if (table === TableName.PURCHASE_ORDERS) {
            return buildPurchase(data)
        } else if (table === TableName.SALE_ORDERS) {
            return buildSale(data)
        } else if (table === TableName.HOARD_ORDERS) {
            return buildHoard(data)
        }
    }

    const buildItemDeliveryStats = (data: Data2) => {
        const { toBeEmitted, pending, emitted } = data
        const itemDeliveryStats: ItemDeliveryStats = {
            toBeEmitted: toBeEmitted! as number,
            pending: pending! as number,
            emitted: emitted! as number
        }

        return itemDeliveryStats
    }

    const buildItem = (data: Data2) => {
        const {
            id = newId(),
            productId,
            lotId,
            quantity: quantityData,
            cancelledQuantity,
            invoiceStats,
            price,
            discounts,
            specialDiscountYield,
            customerTypeYield,
            vatTaxYield,
            manualUnitDiscount,
            deliveryStats
        } = data
        const quantity = quantityData! as number
        const item: Item = {
            id: id! as string,
            productId: productId! as string,
            lotId: lotId! as string,
            quantity,
            cancelledQuantity: cancelledQuantity as O<number>,
            invoiceStats: invoiceStats as O<ItemInvoiceStats>,
            price: price! as number,
            currency: Currency.ARS,
            discounts: discounts as O<Discount[]>,
            specialDiscountYield: specialDiscountYield as O<number>,
            customerTypeYield: customerTypeYield as O<number>,
            vatTaxYield: vatTaxYield as O<number>,
            manualUnitDiscount: manualUnitDiscount as O<number>,
            deliveryStats: (deliveryStats || buildItemDeliveryStats({
                toBeEmitted: quantity,
                pending: quantity,
                emitted: 0
            })) as ItemDeliveryStats
        }

        return item
    }

    return {
        buildOperation,
        buildItemDeliveryStats,
        buildItem
    }
}
